import React from 'react';
import { styled, Swiper, LazyImage } from '@teko/ui';
import { CloseOutlined } from '@teko/ds-icon';
import { CustomLink } from '../Common/CustomLink/CustomLink.es.js';

const TopBannerHeight = styled.div `
  height: 56px;
  position: relative;
  .swiper-slide {
    transition-property: opacity !important;
  }
  @media print {
    display: none;
  }
`;
const ButtonClose = styled.button `
  position: absolute;
  right: 10px;
  top: 16px;
  background-color: transparent;
  border: 0;
`;
const TopBanners = ({ banners, onClose, }) => (React.createElement(TopBannerHeight, null,
    React.createElement(Swiper, { effect: "fade", autoplay: {
            delay: 5000,
            waitForTransition: false,
            disableOnInteraction: false,
        }, loop: true, slidesPerView: 1 }, banners.map((banner, index) => {
        return (React.createElement("div", { key: index, className: "swiper-slide" },
            React.createElement(CustomLink, { targetPath: banner.targetPath },
                React.createElement(LazyImage, { imageWidth: 1920, cover: true, height: 56, src: banner.image, alt: banner.campaignName }))));
    })),
    onClose && (React.createElement(ButtonClose, { onClick: onClose },
        React.createElement(CloseOutlined, { color: "#FFF" })))));

export { TopBanners };
